export default __webpack_public_path__ + "images/google.1dfd887bf01d85331f921a978d211317.svg";